import { render, staticRenderFns } from "./randomReqRegister.vue?vue&type=template&id=59e348c2&"
import script from "./randomReqRegister.vue?vue&type=script&lang=js&"
export * from "./randomReqRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports